// src/App.jsx
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/contexts/AuthContext';
import { ProtectedRoute } from '@/components/common/ProtectedRoute';
import { ProfileGuard } from '@/components/common/ProfileGuard';
import { Layout } from '@/components/layout/Layout';
import { LoginPage } from '@/pages/Login';
import { HomePage } from '@/pages/Home';
import { PixelsPage } from '@/pages/Pixels';
import { IntegrationsPage } from '@/pages/Integrations';
import { ProfilePage } from '@/pages/Profile';
import { queryClient } from '@/lib/react-query';

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Layout>
                    <ProfilePage />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <ProfileGuard>
                    <Layout>
                      <HomePage />
                    </Layout>
                  </ProfileGuard>
                </ProtectedRoute>
              }
            />
            <Route
              path="/pixels"
              element={
                <ProtectedRoute>
                  <ProfileGuard>
                    <Layout>
                      <PixelsPage />
                    </Layout>
                  </ProfileGuard>
                </ProtectedRoute>
              }
            />
            <Route
              path="/integrations"
              element={
                <ProtectedRoute>
                  <ProfileGuard>
                    <Layout>
                      <IntegrationsPage />
                    </Layout>
                  </ProfileGuard>
                </ProtectedRoute>
              }
            />
            {/* Catch-all route for 404s - redirects to home or login based on auth state */}
            <Route
              path="*"
              element={
                <ProtectedRoute>
                  <Navigate to="/" replace />
                </ProtectedRoute>
              }
            />
          </Routes>
        </AuthProvider>
      </Router>
    </QueryClientProvider>
  );
}
